import _ from "underscore";

import uniformatLevel1 from "../../../resources/uniformat/level_1.json";
import uniformatLevel2 from "../../../resources/uniformat/level_2.json";
import uniformatLevel3 from "../../../resources/uniformat/level_3.json";
import uniformatLevel4 from "../../../resources/uniformat/level_4.json";
import { buildBreakdownFromList } from "./breakdown";

import type { Level1Id, Level2Id, Level3Id, Level4Id, UniformatId } from "uniformat";

let data = _(uniformatLevel1).map((level1Label, level1Code) => ({
  label: level1Label,
  code: level1Code as UniformatId,
  subtitle: level1Code as string,
  childCodes: _.chain(uniformatLevel2)
    .keys()
    .filter((level2Code) => level2Code.startsWith(level1Code))
    .value() as UniformatId[],
  parentCode: null as UniformatId
}));

data = data.concat(_(uniformatLevel2).map((level2Label, level2Code) => ({
  label: level2Label,
  code: level2Code as Level2Id,
  subtitle: level2Code,
  childCodes: _.chain(uniformatLevel3)
    .keys()
    .filter((level3Code) => level3Code.startsWith(level2Code))
    .value(),
  parentCode: level2Code[0] as Level1Id
})));

data = data.concat(_(uniformatLevel3).map((level3Label, level3Code) => ({
  label: level3Label,
  code: level3Code as Level3Id,
  subtitle: level3Code,
  childCodes: _.chain(uniformatLevel4)
    .keys()
    .filter((level4Code) => level4Code.startsWith(level3Code))
    .value(),
  parentCode: level3Code.substring(0, 3) as Level2Id
})));

data = data.concat(_(uniformatLevel4).map((level4Label, level4Code) => ({
  label: level4Label,
  code: level4Code as Level4Id,
  subtitle: level4Code,
  childCodes: [],
  parentCode: level4Code.substring(0, 5) as Level3Id
})));

export const uniformatTradeBreakdown = buildBreakdownFromList(data, { id: "code", childIds: "childCodes", parentId: "parentCode" });

export const tradeFilterBreakdown = (trades: object, tradesTsvFilter: boolean) => {
  if (tradesTsvFilter && trades) {
    return buildBreakdownFromList(Object.values(trades), {
      id: "code",
      parentId: "parentCode",
      childIds: "childCodes",
      transform: (trade) => ({ ...trade, subtitle: trade.code })
    });
  } else {
    return uniformatTradeBreakdown;
  }
};

export default tradeFilterBreakdown;
